var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter-container",style:(_vm.containerStyle)},[_c('div',{staticClass:"counter-value",style:(_vm.valueStyle)},[_vm._v(_vm._s(_vm.value))]),_c('el-divider',{staticClass:"divider"}),_c('div',{staticClass:"counter-label-container"},[_c('span',{staticClass:"counter-label"},[_vm._v(_vm._s(_vm.$t(_vm.labelI18nKey)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }